MaterialTooltip.prototype.CssClasses_.DIRECTION_SWITCHED = 'direction-switched';

/**
 * Wir überschreiben den Tooltip-Handler, um prüfen zu können ob das Tooltip ausserhalb des Fenster liegt
 * @param event
 * @private
 */
MaterialTooltip.prototype.handleMouseEnter_ = function(event) {

    // Über das CUstom-Attribut "--content-tooltip" können wir ermitteln ob das Tooltip im Main-Content liegt
    const contentTooltip = window.getComputedStyle(this.element_).getPropertyValue('--content-tooltip');
    // Ermitteln ob das Menü-Links ausgefahren ist
    const menuLeftVisible = document.getElementById('nav-drawer').classList.contains('mdl-layout--fixed-drawer') || document.getElementById('nav-drawer-content').classList.contains('is-visible');

    // Wenn das Tooltip im Main-Content liegt und das Menü ausgefahren ist, muss das Tooltip 240 px vom linken rand liegen, sonst darf es nicht über den linken Rand hinaus
    const minX = menuLeftVisible && contentTooltip ? 240 : 0;
    // Tooltip darf nicht über den rechten Rand hinaus
    const maxX = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    // Der Header-Balken ist 60px hoch, Tooltip darn nicht drüber hinaus
    const minY = 60;
    // Tooltip dard nicht über den unteren Rand hinaus
    const maxY = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);

    // Standard Funktionalität von mdl-tooltip
    var props = event.target.getBoundingClientRect();
    var left = props.left + (props.width / 2);
    var top = props.top + (props.height / 2);
    var marginLeft = -1 * (this.element_.offsetWidth / 2);
    var marginTop = -1 * (this.element_.offsetHeight / 2);

    // Höhe und Breite des Tooltip ermitteln um ermitteln zu können ob es ausserhalb vom sichtbaren Bereich liegt
    const h = this.element_.offsetHeight;
    const w = this.element_.offsetWidth;

    if (this.element_.classList.contains(this.CssClasses_.LEFT) || this.element_.classList.contains(this.CssClasses_.RIGHT)) {
        left = (props.width / 2);
        if (top + marginTop < 0) {
            this.element_.style.top = '0';
            this.element_.style.marginTop = '0';
        } else if((top + h + marginTop) > maxY) {
            this.element_.style.top = (maxY - h) + 'px';
            this.element_.style.marginTop = '0';
        } else {
            this.element_.style.top = top + 'px';
            this.element_.style.marginTop = marginTop + 'px';
        }
    } else {
        if (left + marginLeft < 0) {
            this.element_.style.left = '0';
            this.element_.style.marginLeft = '0';
        } else if((left + w + marginLeft) > maxX) {
            this.element_.style.left = (maxX - w) + 'px';
            this.element_.style.marginLeft = '0';
        } else {
            this.element_.style.left = left + 'px';
            this.element_.style.marginLeft = marginLeft + 'px';
        }
    }


    if (this.element_.classList.contains(this.CssClasses_.TOP)) {
        const ttTop = props.top - h - 10;
        if(ttTop < minY && !this.element_.classList.contains(this.CssClasses_.DIRECTION_SWITCHED)) {
            // Falls das Tooltip überhalb des Element angezeigt werden soll, aber über den oberen Rand läuft, wird es unterhalb angezeigt
            this.element_.classList.add(this.CssClasses_.BOTTOM);
            this.element_.classList.remove(this.CssClasses_.TOP);
            this.element_.style.top = props.top + props.height + 10 + 'px';

            this.element_.classList.add(this.CssClasses_.DIRECTION_SWITCHED);
        } else {
            this.element_.style.top = ttTop + 'px';
        }
    } else if (this.element_.classList.contains(this.CssClasses_.RIGHT)) {
        const ttLeft = props.left + props.width + 10;
        if(ttLeft + w > maxX && !this.element_.classList.contains(this.CssClasses_.DIRECTION_SWITCHED)) {
            // Falls das Tooltip rechts vom Element angezeigt werden soll, aber über den rechten Rand läuft, wird es links angezeigt
            this.element_.classList.add(this.CssClasses_.LEFT);
            this.element_.classList.remove(this.CssClasses_.RIGHT);
            this.element_.style.left = Math.max(5, props.left - w - 10) + 'px';

            this.element_.classList.add(this.CssClasses_.DIRECTION_SWITCHED);
        } else {
            this.element_.style.left = Math.max(5, ttLeft) + 'px';
        }
    } else if (this.element_.classList.contains(this.CssClasses_.LEFT)) {
        // position ermitteln falls das Tooltip links angezeigt werden würde
        var ttLeft = props.left - w - 10;
        if(ttLeft < minX && !this.element_.classList.contains(this.CssClasses_.DIRECTION_SWITCHED)) {
            // Falls das Tooltip links vom Element angezeigt werden soll, aber über den linken Rand läuft, wird es rechts angezeigt
            this.element_.classList.add(this.CssClasses_.RIGHT);
            this.element_.classList.remove(this.CssClasses_.LEFT);
            this.element_.style.left = Math.max(5, props.left + props.width + 10) + 'px';

            this.element_.classList.add(this.CssClasses_.DIRECTION_SWITCHED);
        } else {
            this.element_.style.left = Math.max(5, ttLeft) + 'px';
        }
    } else {
        var ttTop = props.top + props.height + 10;
        if((ttTop + h) > maxY && !this.element_.classList.contains(this.CssClasses_.DIRECTION_SWITCHED)) {
            // Falls das Tooltip unterhalb des Element angezeigt werden soll, aber über den unteren Rand läuft, wird es oberhalb angezeigt
            this.element_.classList.add(this.CssClasses_.TOP);
            this.element_.classList.remove(this.CssClasses_.BOTTOM);
            this.element_.style.top = props.top - h - 10 + 'px';

            this.element_.classList.add(this.CssClasses_.DIRECTION_SWITCHED);
        } else {
            this.element_.style.top = ttTop + 'px';
        }
    }

    this.element_.classList.add(this.CssClasses_.IS_ACTIVE);
};